import React from 'react';
import { ButtonTheme } from '../../../ui-components/PlayButton/PlayButton';
import {
    Heading,
    SearchSuggestionList,
    SearchSuggestionListItem,
    ShowAllListItem,
    ShowSearchResultButton,
    SuggestionsPopOver,
} from './AutoCompleteResult.styles';
import { getId, value } from './helpers';
import PopOverLink from './PopOverLink';

const AutoCompleteButton = ({ searchTerm, onClick }) => (
    <ShowAllListItem>
        <ShowSearchResultButton
            to="/sok"
            query={{ q: searchTerm }}
            onClick={onClick}
            data-rt-spec="search-result-btn"
            theme={ButtonTheme.DARK}
        >
            <span className="play_search-suggestions__show-all-icon" aria-hidden="true" />
            Visa alla sökträffar
        </ShowSearchResultButton>
    </ShowAllListItem>
);

const PopOver = ({ result, suggestionClick, term, onAllMatchesClick, onItemImpression }) => (
    <SuggestionsPopOver portal={false} data-state="suggesting">
        {result.name && <Heading>{result.name}</Heading>}
        <SearchSuggestionList key={JSON.stringify(result.hits)}>
            {result.hits.map((item, index) => (
                <SearchSuggestionListItem key={getId(item)} value={value(item)}>
                    <PopOverLink
                        item={item}
                        suggestionClick={suggestionClick}
                        itemPosition={index}
                        onItemImpression={onItemImpression}
                    />
                </SearchSuggestionListItem>
            ))}
            {term !== '' && <AutoCompleteButton searchTerm={term} onClick={onAllMatchesClick} />}
        </SearchSuggestionList>
    </SuggestionsPopOver>
);

export default PopOver;
